<template>
    <div class="max-w-4xl mx-auto text-center">
        <h2 class="text-2xl font-semibold mb-10">Frequently Asked Questions</h2>
            <div class="space-y-4">
              <div class="bg-gray-700 rounded-lg" v-for="(item, index) in faqs" :key="index">
                <!-- Question -->
                <button class="w-full text-left px-6 py-4 focus:outline-none text-md font-semibold hover:bg-gray-600" @click="toggleFAQ(index)">
                  <span v-html="item.question"></span>
                  <!-- Dropdown Icon -->
                  <span class="float-right">
                    <svg :class="{'transform rotate-180': activeFAQ === index}" class="transition-transform duration-200" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M3 6l3 3 3-3h4l-5 5-5-5z"></path>
                    </svg>
                  </span>
                </button>
                <!-- Answer -->
                <div v-if="activeFAQ === index" class="px-6 py-4 text-gray-300">
                  <span v-html="item.answer"></span>
                </div>
              </div>
            </div>
          </div>
</template>
<script setup>
    import { ref } from 'vue'
    const activeFAQ = ref('')

    const faqs = ref([
        {
            question: 'What is OPPI?',
            answer: 'OPPI (Opportunities by Sci-Pi) is a platform designed to connect students with various competitions, awards, and community involvement opportunities. It aims to help students find activities that can help them grow and stand out.'
        },
        {
            question: 'How can I submit an opportunity?',
            answer: 'You can submit an opportunity by clicking on the "Submit" button at the top of the page. Simply fill in the details of the opportunity, such as category, deadline, and a description, and your opportunity will be listed on the platform.'
        },
        {
            question: 'Is OPPI free to use?',
            answer: 'Yes! OPPI is completely free for users to browse and discover opportunities. We aim to provide a platform where all students can easily access valuable information without any cost.'
        },
        {
            question: 'How can I stay updated on new opportunities?',
            answer: 'You can subscribe to our newsletter to receive updates directly in your inbox. Additionally, follow us on social media to get real-time notifications of new opportunities.'
        },
        {
            question: 'How can I get in touch with the OPPI team?',
            answer: 'You can contact the OPPI team by emailing us at support@oppi.com or using the contact form available on our "Contact Us" page.'
        }
    ])
    

  const toggleFAQ = (faqId) => {
      activeFAQ.value = activeFAQ.value === faqId ? null : faqId;
  }
    
</script> 
<script>
    export default {
        name: 'FrequentlyAskedQuestions'
    }
</script>